import React from 'react';

import { Badge } from '@material-ui/core';

import NotificationContent from './NotificationContent';
import { ReactComponent as NotificationIcon } from '../../images/dashbaordNoti.svg';

export default function badge({
  isMainScreen,
  onclickNotificationIcon,
  notificationOpen,
  pendingNotifications,
  allNotifications,
  setNotificationOpen,
  tokenData,
  onclickNotification,
}) {
  return (
    <>
      <div className='p-relative'>
        <Badge
          className='notificationBadge'
          badgeContent={pendingNotifications?.length}
          color='primary'
          style={{
            cursor: window.location.pathname === '/notifications' && 'default',
          }}
          onClick={
            window.location.pathname === '/notifications'
              ? null
              : onclickNotificationIcon
          }
        >
          <NotificationIcon className='notification__icon' />
        </Badge>
        {notificationOpen && (
          <NotificationContent
            isMainScreen={isMainScreen}
            notifications={allNotifications || []}
            tokenData={tokenData}
            onclickNotification={onclickNotification}
            setNotificationOpen={setNotificationOpen}
          />
        )}
      </div>
    </>
  );
}
